<template>
  <div class="bg-gray-900 w-full min-h-screen">
    <slot></slot>
  </div>
</template>

<script setup></script>
